<template>
  <chicklet
    v-if="dueDate"
    :color="dueDateColor"
    :size="size"
    :title="dueDateFormatted"
    type="transparent">
    <span>{{ dueDateFormatted }}</span>
  </chicklet>
</template> 

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import dayjs from '@/helpers/dayjs'

/* Mixins */

/* Components */
import chicklet from './chicklet.vue'

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'DueDateChicklet',

  components: {
    chicklet,
  },

  props: {
    dueDate: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'tiny',
    },
  },

  computed: {
    isDueDateOverdue(): boolean {
      if (this.dueDate) {
        return dayjs(new Date()).isAfter(this.dueDate)
      }
      return false
    },

    isDueDateInTwoDays(): boolean {
      if (this.dueDate) {
        return dayjs(new Date()).isAfter(
          dayjs(this.dueDate).subtract(2, 'days'),
        )
      }
      return false
    },

    dueDateColor(): string {
      if (this.isDueDateOverdue) {
        return 'strawberry'
      } else if (this.isDueDateInTwoDays) {
        return 'light-orange'
      } else {
        return 'grey'
      }
    },

    dueDateFormatted(): string {
      if (this.dueDate) {
        if (dayjs(this.dueDate).isSame(new Date(), 'year')) {
          return dayjs(this.dueDate).format('MMM D')
        } else {
          return dayjs(this.dueDate).format('MMM D, YYYY')
        }
      }
      return ''
    },
  },
})
</script>
